import * as types from '../mutation-types'
import store from '~/store'
import moment from 'moment'

import {
  newDateFormat,
} from '../../plugins/helper'

// state
export const state = {
  day: 0,
  days: [],
  current_day: 0,
  senior_date: null,
}

const months = [
  'ENERO',
  'FEBRERO',
  'MARZO',
  'ABRIL',
  'MAYO',
  'JUNIO',
  'JULIO',
  'AGOSTO',
  'SEPTIEMBRE',
  'OCTUBRE',
  'NOVIEMBRE',
  'DICIEMBRE',
]

// mutations
export const mutations = {
  [types.GET_DAY_MONTH] (state, day) {
    state.day = day
  },

  [types.GET_DAY_MONTH_CURRENT_YEAR] (state, day) {
    state.current_day = day
  },

  [types.GET_DAYS_OF_THE_MONTH] (state, day) {
    const temp = []
    let index = 1

    while (index <= day) {
      temp.push(index)
      index++
    }

    state.days = temp
  },

  [types.GET_MAJOR_DATE] (state, dates) {
    if (dates.length === 0) {
      state.senior_date = moment(new Date(), 'DD-MM-YYYY')
    }

    let firstDate = newDateFormat(dates[0])
    dates.forEach(date => {
      const lastDate = newDateFormat(date)
      if (firstDate < lastDate) {
        firstDate = lastDate
      }
    })

    state.senior_date = firstDate
  },
}

// actions
export const actions = {
  /**
   * @param {String} month
   * @param {Number} year
   */
  async daysInAMonth ({ commit }, { month, year }) {
    month = month.toUpperCase()
    const day = new Date(year, months.indexOf(month) + 1, 0)
      .getDate()

    commit(types.GET_DAY_MONTH, day)
  },

  async daysOfTheMonthCurrentYear ({ commit }) {
    const date = new Date()
    const day = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .getDate()

    commit(types.GET_DAY_MONTH_CURRENT_YEAR, day)
  },

  async daysOfTheMonth ({ commit }) {
    await store.dispatch('daysOfTheMonthCurrentYear')
    const day = store.getters.current_day

    commit(types.GET_DAYS_OF_THE_MONTH, day)
  },

  /**
   * @param {Array} dates
   */
  async searchMajorDate ({ commit }, dates) {
    commit(types.GET_MAJOR_DATE, dates)
  },
}

// getters
export const getters = {
  day: state => state.day,
  days: state => state.days,
  current_day: state => state.current_day,
  senior_date: state => state.senior_date,
}
